import React from 'react'
import Subheader from '../../component/Subheader'
import HaldiHead from '../Haldi/HaldiHead';
import HaldiImage from '../Haldi/HaldiImage';
import HaldiBook from '../Haldi/HaldiBook';
import HaldiGallery from '../Haldi/HaldiGallery';
import HaldiCraft from '../Haldi/HaldiCraft';
import HaldiInstagram from '../Haldi/HaldiInstagram';
import HaldiLogoslider from '../Haldi/HaldiLogoslider';
import HaldiService from '../Haldi/HaldiService';

export default function Festive() {
    const subheadData = {
      image: '/image/festive-banner.webp',
      heading: 'Festive Couture Rooted in Indian Tradition',
      pagename: 'Festive',
    }


    const headdata = {
        title: "Where Festivity Meets Refined Craft",
        heading: "The Art of Modern Festive Dressing",
        description:"At Sonam Label, festive fashion is elevated through rich craftsmanship, vibrant detailing, and silhouettes that honour Indian tradition with a contemporary spirit. Each ensemble is thoughtfully designed with ornate embellishments, graceful drapes, and celebratory hues that capture the joy of Indian festivals. Balancing opulence with comfort, our Festival Edit is crafted for women who embrace tradition while expressing individuality-making every celebration feel radiant, meaningful, and exquisitely styled.",
        buttonText: "Learn More",
        link: "/contact",
    };


    const haldiimage = [
        { src: "/image/festive-img-1.webp", alt: "festive" },
        { src: "/image/festive-img-2.webp", alt: "festive" },
        { src: "/image/festive-img-3.webp", alt: "festive" },
    ];


    const haldiService = {
      tagline: "Festival Collection",
      heading: "Celebrations, Crafted in Style",
      image: "/image/festive-service.webp",
      accordions: [
        {
          title: "Festive Glamour, Elevated",
          description:"Every creation reflects masterful artistry, featuring intricate hand embroidery, festive accents, and luxurious textures that embody joy, elegance, and the unmistakable Sonam aesthetic."
        },
        {
          title: "Ornate Embellishments & Rich Fabrics",
          description:"From detailed zari and threadwork to layered, fluid fabrics, each piece celebrates the richness of Indian craftsmanship while offering modern sophistication."
        },
        {
          title: "Statement Looks for Every Celebration",
          description:"Designed to stand out with grace, our festive ensembles blend bold detailing with refined silhouettes—perfect for creating memorable, eye-catching moments."
        },
        {
          title: "Crafted for Festivities & Family Gatherings",
          description:"Ideal for pujas, weddings, soirées, and festive celebrations, each design ensures comfort, movement, and effortless elegance throughout the day and night."
        },
        {
          title: "The Sonam Festive Signature",
          description:"Rooted in heritage yet styled for today, our festive creations reflect timeless craftsmanship, modern sensibility, and cultural richness—defining the Sonam Label identity."
        },
      ]
    };


    const haldigallery = [
        { src: "/image/festivegallery-1.webp"},
        { src: "/image/festivegallery-2.webp"},
        { src: "/image/festivegallery-3.webp"},
        { src: "/image/festivegallery-4.webp"},
        { src: "/image/festivegallery-5.webp"},
    ];


    const haldiCraft = {
      heading: "Where Celebration Finds Its Rhythm",
      description:"Sonam Label’s festive edit reimagines Indian celebration wear through graceful silhouettes, rich textures, and intricately crafted details. Designed for the modern woman who cherishes tradition with a contemporary sensibility, each ensemble allows joyful movement, radiant presence, and effortless festive elegance."
    };


    const haldiInsta = [
      {image: "/image/mehandiinsta-1.webp"},
      {image: "/image/mehandiinsta-2.webp"},
      {image: "/image/mehandiinsta-3.webp"},
      {image: "/image/mehandiinsta-4.webp"},
      {image: "/image/mehandiinsta-5.webp"},
    ];

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <HaldiHead headdata={headdata}/>
    <HaldiImage haldiimage={haldiimage}/>
    <HaldiLogoslider/>
    <HaldiService haldiService={haldiService}/>
    <HaldiBook/>
    <HaldiGallery haldigallery={haldigallery}/>
    <HaldiCraft haldiCraft={haldiCraft}/>
    <HaldiInstagram haldiInsta={haldiInsta}/>
    </>
  )
}
